define([
	"dojo/_base/declare",
	"csi/action/NewController",
	"csi/xml"
], function(declare,NewController,xml) {

	return declare(NewController, {
		bUpdateParent: false,

		onCreatePopup: function(/*csi.view.Widget*/view) {
			// summary: set default value for request level
			view.addFixedValue("OrdersByColor", true);
			this.inherited(arguments);
		},

		toWriter: function() {
			this.inherited(arguments);

			this.m_writer.callMethod("Sourcing", "POAddProduct")
				.addParameter(xml.PROP_URL, xml.ATTR_REF, this.m_urlNode)
				.addParameter(xml.PROP_AGGREGATE_ADD, xml.ATTR_REF, this.m_urlParent);

			return null;
		},

		postProcessSuccess: function() {
			// summary: refresh page if not navigating to new PO
			return this.bNavigate ? this.inherited(arguments) : this.widget.refreshData();
		}
	});
});